interface ErrorMessages {
    [key: string]: string;
}

export const gqlErrorsToToasts = (errors: ErrorMessages) => {
    return Object.entries(errors).map(([, payload]) => ({
        variant: 'error' as const,
        message: payload,
    }));
};
